<template>
  <div @click.self="closeModal" class="modalContainer">
    <div class="modalWrapper">
      <div @click="closeModal" class="close">
        <img src="@/assets/icons/close.svg" alt="close" />
      </div>
      <h2>Should this Order be Tax Exempt?</h2>
      <div class="buttonContainer">
        <button
          @click="confirmTaxExempt"
          :disabled="confirmButtonLoader"
          class="secondaryButtons"

        >
          <div v-if="confirmButtonLoader" class="loader buttonLoader"></div>
          <template v-else>Yes, do not charge tax</template>
        </button>

        <button @click="denyTaxExempt" class="secondaryButtons" :disabled="denyButtonLoader">
          <div v-if="denyButtonLoader" class="loader buttonLoader"></div>
          <template v-else>No, charge tax</template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import modalMixins from '@/mixins/modalMixins.js'
import { mapState } from 'vuex'

export default {
  mixins: [modalMixins],
  props: ['confirmButtonLoader', 'denyButtonLoader'],
  computed: {
    ...mapState(['branding']),
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    confirmTaxExempt() {
      this.$emit('taxExemptDecision', { exempt: true })
      this.closeModal()
    },
    denyTaxExempt() {
      this.$emit('taxExemptDecision', { exempt: false })
      this.closeModal()
    },
  },
}
</script>

<style src="../../../assets/css/Modals/StoreModals/TaxExemptModal.css" scoped></style>